
var ary_slide_loading_condition=[];

class ExternSplideSlide extends HTMLElement {
  constructor() {
    super();
    let slideUrl = this.getAttribute('src');
    //console.log("slide url:"+slideUrl);
  }
  connectedCallback() {
    let slideUrl = this.getAttribute('src');
    fetch(slideUrl)
      .then(response => response.text())
      .then(text => {
        let temp_DOM_container = document.createElement('div');
        temp_DOM_container.insertAdjacentHTML('afterbegin',text);
        this.replaceWith(temp_DOM_container.firstElementChild);

        ary_slide_loading_condition.push(slideUrl);
      });
  }
}

module.exports.define_splide_slide_element = () => {
    customElements.define('extern-splide-slide', ExternSplideSlide);
}


module.exports.get_load_stat_splide_slide_element = () => {
    return ary_slide_loading_condition;
}

/**
 * 
 * @param {*} ary_load_condision 読み込み状態
 * 
 * @note
 * ary_slide_loading_conditionとary_load_condisionが一致した時点で、
 * イベントを発生させる
 */
module.exports.emit_on_all_splide_slide_loaded = (ary_assumed_load_condision,event_name="allsplideslideloaded") => {

  const check_all_loading_finished = ()=>{
    let load_all;

    load_all = ary_assumed_load_condision.every((e)=>ary_slide_loading_condition.includes(e));
    if(load_all){
        evt = new CustomEvent(event_name,{detail:{
          ary_slide_loading_condition
        }});
        window.dispatchEvent(evt);
    } else {
      setTimeout(check_all_loading_finished,100);
    }
  }

  setTimeout(check_all_loading_finished,100);
}
